
    import { annotate, annotationGroup } from 'https://unpkg.com/rough-notation?module';
    window.annotate = annotate;
    window.annotationGroup = annotationGroup;
  